import Head from "next/head"
import { FC, PropsWithChildren } from "react"
import tw from "tailwind-styled-components"
import OnboardingHeader from "./components/OnboardingHeader"

const ChildContainer = tw.div`
  flex
  flex-col
  justify-start
  items-center
  w-full
  h-full
`

const OnboardingLayout: FC<
  PropsWithChildren<{
    title?: string
    includeMenu?: boolean
    large?: boolean
  }>
> = ({ children, title, includeMenu = false, large = false }) => {
  return (
    <>
      <Head>
        <title>{title || "paywall"}</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <main className={`h-screen flex flex-col flex-1`}>
        <OnboardingHeader includeMenu={false} />
        <div className=""></div>
        <ChildContainer>
          <div
            className={`mt-4 md:mt-16 lg:mt-40 w-full ${
              large ? "max-w-[900px]" : "max-w-[652px]"
            } px-5`}
          >
            {children}
          </div>
        </ChildContainer>
      </main>
    </>
  )
}

export default OnboardingLayout
